import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import React from 'react';

interface AddBlacklistDialogProps {
  open: boolean;
  onClose: () => void;
  businessName: string;
  reason: string;
  onReasonChange: (reason: string) => void;
  onAdd: () => void;
  loading: boolean;
}

const AddBlacklistDialog: React.FC<AddBlacklistDialogProps> = ({
  open,
  onClose,
  businessName,
  reason,
  onReasonChange,
  onAdd,
  loading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="form-dialog-title"
      maxWidth="md"
    >
      <DialogTitle
        id="form-dialog-title"
        sx={{ fontSize: '1.1rem', fontWeight: 600 }}
      >
        Agregar empresa a la blacklist
      </DialogTitle>
      <DialogContent sx={{ minWidth: '500px' }}>
        {!loading && (
          <>
            <Typography variant="body1" sx={{ fontSize: '0.95rem', mb: 2 }}>
              {businessName}
            </Typography>
            <TextField
              autoFocus
              margin="dense"
              id="reason"
              label="Razón"
              type="text"
              fullWidth
              value={reason}
              onChange={(e) => onReasonChange(e.target.value)}
              placeholder="Ingresar razón para agregar a la blacklist..."
              sx={{
                '& .MuiInputBase-input': {
                  fontSize: '0.9rem',
                },
                '& .MuiInputLabel-root': {
                  fontSize: '0.9rem',
                },
              }}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={onClose} color="secondary" disabled={loading}>
          Cancelar
        </CustomButton>
        <CustomButton onClick={onAdd} color="error" disabled={loading}>
          Añadir
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default AddBlacklistDialog;
